import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  NetworkUtilsService,
  URL_DICT,
} from 'projects/app-core/src/service/network-utils.service';
import {
  AddUserInterestTagsRequest,
  LyfisMasterDataResponse,
  MasterDataResponse,
  SeasonalUserInterestTags,
} from '../models/masterDataResponse';
import { TherapyVerticals } from 'projects/app-core/src/models/TherapyVerticals';
import { TherapyConcerns } from 'projects/app-core/src/models/TherapyConcerns';
import { IAnyoPartner } from '../models/IPartner';

export interface AddEditVerticalMasterDataReq {
  verticalName: string;
  image: string;
  primaryColor: string;
  secondaryColor: string;
  verticalId?: string;
  sessionInterval: number;
  isVisible: boolean;
  userSelectSessionDuration: boolean;
  isHealthProgram?: boolean;
  description?: string;
  notApplicablePartner?: string[];
  sessionIntervals?: Record<string, number | null>;
}

export interface AddEditConcernMasterDataReq {
  concernName: string;
  verticalId: string;
  concernId?: string;
  image?: string;
  description?: string;
  expertiseTagline?: string;
  isVisible: boolean;
  sessionInterval: number;
  userSelectSessionDuration: boolean;
  notApplicablePartner?: string[];
  sessionIntervals?: Record<string, number | null>;
}

interface VerticalConcernGetReq {
  concernId?: string;
  verticalId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class MasterdataService {
  protected basePath = environment.serviceUrl;
  constructor(
    protected httpClient: HttpClient,
    private api: NetworkUtilsService,
  ) {}

  public masterDataList() {
    return this.api.get<MasterDataResponse>(URL_DICT.getMasterData);
  }

  public lyfisMasterDataList() {
    return this.api.get<LyfisMasterDataResponse>(URL_DICT.getLyfisMasterData);
  }

  public partnerMasterDataList() {
    return this.api.get<IAnyoPartner[]>(URL_DICT.getMasterDataPartners);
  }

  public getVerticalConcern(req: VerticalConcernGetReq) {
    return this.api.post<TherapyVerticals | TherapyConcerns>(
      URL_DICT.adminGetVerticalConcernUrl,
      req,
    );
  }

  public addVertical(req: AddEditVerticalMasterDataReq) {
    return this.api.post(URL_DICT.adminAddVerticalUrl, req);
  }

  public addConcern(req: AddEditConcernMasterDataReq) {
    return this.api.post(URL_DICT.adminAddConcernUrl, req);
  }

  public getSessionalUserInterestTags() {
    return this.api.get<SeasonalUserInterestTags[]>(
      URL_DICT.getSessionalTagUrl,
    );
  }

  public addSessionalUserInterestTags(req: AddUserInterestTagsRequest) {
    return this.api.post(URL_DICT.addSessionalTagUrl, req);
  }
}
